import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-not-found-result',
  templateUrl: './not-found-result.component.html',
  styleUrls: ['./not-found-result.component.scss']
})
export class NotFoundResultComponent implements OnInit {
  @Input() errorMsg: any;
  constructor() { }

  ngOnInit() {
  }

}
